import { useState, useEffect, useMemo } from 'react';
import { Column } from 'react-table';
import i18next from 'i18next';
import { useTranslation } from 'react-i18next';
import { useQuery } from '@tanstack/react-query';
import { Card, Col, Row } from 'react-bootstrap';
import { columnsData } from '../columnsListPud';
import VehicleTableContainer from '../../VehicleTable/VehicleTableContainer';
import ErrorBoundary from '../../ErrorBoundary/ErrorBoundary';
import toaster from '../../../utils/toaster';
import TiassistoElement from '../TiassistoElement';
import ModalPud from '../ModalCreatePud/ModalsPud';
import { useApiClient } from '../../../hooks/useApiClient';
import useStore from '../../../store/TiassistoStore';
import _ from 'lodash';
import { TiassistoPudHistoryDTO } from '../../../api';

interface OpenModals {
  createPud: boolean;
  detailsPud: boolean;
}

const HistoryPudList = ({ vehicleId: targa }) => {
  const [openModal, setOpenModal] = useState<OpenModals>({ createPud: false, detailsPud: false });
  const [loading, setLoading] = useState<boolean>(true);
  const [historyPudList, setHistoryPudList] = useState<TiassistoPudHistoryDTO[]>([]);
  const { t } = useTranslation()
  const { apiClient, handleApi } = useApiClient();
  const { vehicle, setPudId, pudId, setPudDetails, pudDetails, } = useStore();


  useEffect(() => {
    if (targa) {
      // FETCH ALL ACTIVE PUD
      handleApi(apiClient.tiassistoController.getPudsHistory(targa))
        .then(res => {
          setHistoryPudList(res.pudHistory)
        })
        .catch(error => {
          console.error(error)
          // toaster.error(i18next.t('error-fetching_active_pud_list'));
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [targa])

  const columns = useMemo(() => columnsData as Column<Object>[], []);
  const data = useMemo(() => historyPudList ?? [], [historyPudList]);


  const handleDoubleClick = (row) => {
    setOpenModal((prev) => ({ ...prev, detailsPud: true }));
    setPudId(row?.original?.id);
  };

  const { data: responsePudDetails, isLoading: pudListsLoading, error: pudListError, status } = useQuery({
    queryKey: ['singlePud', pudId],
    queryFn: () => apiClient.tiassistoController.getPudDetails(pudId),
    enabled: !!pudId,
    staleTime: 1000 * 60 * 5,
    refetchOnWindowFocus: false,
    retry: false,
  });

  useEffect(() => {
    if (status === 'success' && responsePudDetails) {
      setPudDetails(responsePudDetails);
    }
  }, [status, responsePudDetails, setPudDetails]);

  useEffect(() => {
    if (status === 'error' && pudListError) {
      console.error('Error fetching data: ', pudListError);
      toaster.error(i18next.t("error_fetching_pud_details"));
    }
  }, [status, pudListError]);

  const filterIntialState = {
    status_description: [],
  }

  return (
    <TiassistoElement>

      <div className="mb-4">
        <Row>
          <Col md={6} className="display-6">
            {t("history_pud_list")}
          </Col>
        </Row>

        {!_.isEmpty(data) ?
          <ErrorBoundary>
            <VehicleTableContainer
              columns={columns}
              data={data}
              handleDoubleClick={handleDoubleClick}
              loading={false}
              error={{}}
              filterIntialState={filterIntialState}
            ></VehicleTableContainer>
          </ErrorBoundary>
          : (
            <Card>
              <Card.Body>
                {t("no_pud_history_data_available")}
              </Card.Body>
            </Card>
          )
        }

        {/* Modal Details PUD */}
        <ModalPud
          isOpen={openModal.detailsPud}
          onClose={() => setOpenModal((prev) => ({ ...prev, detailsPud: false }))}
          mode={"details_pud"}
          from={'historyPUD'}
        />
      </div>
    </TiassistoElement>

  )
}

export default HistoryPudList
